export default __webpack_public_path__ + "b0f790971032749bc6880f85ea0d4b4d.svg";